<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field :label="$t('name')" type="text" v-model="item.name" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TopicFilter",
  props: {
    values: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},

  computed: {
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
  },
  methods: {},
};
</script>
